/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Forward_Five_FramesInputs */



/**
* | output |
* | --- |
* | "Forward 5 Frame" |
*
* @param {Shortcut_Keys_Name_Forward_Five_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_forward_five_frames = /** @type {((inputs?: Shortcut_Keys_Name_Forward_Five_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Forward_Five_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer de 5 images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorwärts 5 Frame")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanti 5 fotogrammi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вперед 5 кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar 5 cuadros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前进 5 帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("5フレーム進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आगे 5 फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro 5 para frente")
	return /** @type {LocalizedString} */ ("Forward 5 Frame")
});